module.exports = __webpack_public_path__ + "static/media/connect_2.f0f80ca3.jpg";